<template>
  <div>
    <a-title :text="title" />
    <l-rows>
      <l-rows-row content-position="right">
        <a-button
          v-if="hasAddButton"
          type="button"
          variant="primary"
          :text="addButtonCaption"
          @click="handleAdd"
        />
      </l-rows-row>
    </l-rows>
    <o-list
      :loading="loading"
      :vcentered="true"
      :data="listData"
      :columns="columns || defaultColumns"
      :selectable="selectable"
      @select="selectionChange"
    />
  </div>
</template>

<script>
  import { OList, AButton, ATitle, LRows, LRowsRow } from 'codefabrik-gui-vue'

  export default {
    name: 'BackOfficeList',
    components: { OList, AButton, ATitle, LRows, LRowsRow },
    props: {
      title: {
        type: String,
        default: ''
      },
      hasAddButton: {
        type: Boolean,
        default: false
      },
      addButtonCaption: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      listData: {
        type: Array,
        default: () => []
      },
      routeToAddPage: {
        type: String,
        default: ''
      },
      selectionChange: {
        type: Function,
        default: () => {}
      },
      columns: {
        type: Array,
        default: null
      },
      selectable: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      defaultColumns () {
        return [
          {
            field: 'name',
            header: this.$t('common.name'),
          },
        ]
      }
    },
    methods: {
      handleAdd () {
        this.$router.push({ name: this.routeToAddPage })
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
